import React from 'react';
import './styles.css';
//internal and external components import
import { Select, InputLabel, MenuItem, Box, createTheme, ThemeProvider } from "@mui/material";
import StatusIndicatorSmall from '../StatusIndicatorSmall';
import { colors } from '../../common/pallette/colors';

const SelectBoxPrimary = (props:any) => {
    const { label, options, isStatus, selected, manageChange, report, disabled, leftPosition } = props;
    const handleChange = (event: { target: { value: string } }) => {
        manageChange(event.target.value);
    };
    const theme = createTheme({
        components: {
            MuiSelect: {
                styleOverrides: {
                    select: {
                        paddingTop: 0,
                        paddingBottom: 0,
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        border: 0,
                    },
                    input: {
                        cursor: disabled ? 'not-allowed' : 'pointer',
                    }
                }
            },
            MuiMenu: {
                styleOverrides: {
                    paper: {
                        left: leftPosition,
                    }
                }
            }
        }
    })
    return(
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <Box className={'selectBoxPrimaryWrapper'} sx={{ top: (label === undefined || label !== '') ? '-6px' : '0px' }}>
                    <InputLabel className='selectBoxPrimaryLabel' sx={{display: (label == undefined || label !== '') ? 'block' : 'none', fontSize: 12, float: 'left', mr: '10px'}}>{label}</InputLabel>
                    <Select
                    className={disabled ? 'selectBoxPrimarySelect cursorNotAllowed' : 'selectBoxPrimarySelect'}
                    sx={{ backgroundColor: colors.grey.light }}
                    value={selected}
                    onChange={handleChange}
                    readOnly={disabled}
                    MenuProps={{
                        disablePortal: true,
                        disableAutoFocusItem: true,
                        PaperProps: {
                        onMouseDown: (e: any) => e.stopPropagation(),
                        },
                        anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                        },
                        transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                        },
                    }}
                    >
                    {
                        options.map((option: string) => (
                        <MenuItem className='selectBoxPrimarymenuItem' value={option} key={option}>
                            {isStatus ? <StatusIndicatorSmall reportType={report || ''} status={option} /> : option}
                        </MenuItem>
                        ))
                    }
                    </Select>
                </Box>
            </ThemeProvider>
        </React.Fragment>
    )
}

export default SelectBoxPrimary;